import { useCallback, useEffect, useState } from "react";
import VEHICLE from "../../assets/images/icons/vehicle-white.svg";
import { vehicleCurrentStatusApiUrl } from "./endpoints";
import { getApis } from "./apis";

const VehicleCurrentStatus = ({ vehicle }) => {
  const authToken = localStorage.getItem("authToken");
  const [vehicleStatus, setVehicleStatus] = useState(null);

  const getVehicleCurrentStatus = useCallback(async () => {
    await getApis(
      vehicleCurrentStatusApiUrl,
      {
        imei: vehicle?.vehImei,
      },
      authToken
    )
      .then((response) => {
        setVehicleStatus(response?.data);
      })
      .catch((e) => console.log(e.response?.data?.message));

      // eslint-disable-next-line
  }, [authToken, vehicle?.vehId]);

  useEffect(() => {
    if (vehicle?.vehImei && vehicle?.vehImei !== "") {
      getVehicleCurrentStatus();

      const intervalId = setInterval(() => {
        getVehicleCurrentStatus();
      }, 60 * 1000);

      return () => clearInterval(intervalId);
    }
  }, [vehicle?.vehImei, getVehicleCurrentStatus]);

  return vehicleStatus ? (
    <div
      className={"vehicle-current-status-card " + vehicleStatus.toLowerCase()}
    >
      <img src={VEHICLE} alt="vehicle" className="vehicle-img mr05" />
      <div className="vehicle-status-text">{vehicleStatus}</div>
    </div>
  ) : null;
};

export default VehicleCurrentStatus;
